// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"295": "MiraBriefLobbyButton","787": "BadgeTooltipV1",}[chunkId] + "." + {"295": "76c92df28abda20b","787": "5093d862165bbd7c",}[chunkId] + ".js"
}